import axios from "axios";
import React, { createContext, useEffect, useState } from "react";


const apiValue = createContext();   
const apiValue2 = createContext();  
const apiValue3 = createContext();  
const apiValue4 = createContext();  
function AllData({ children }) {
  const [api, setApi] = useState([]);
  const [api2, setApi2] = useState([]);
  const [api3, setApi3] = useState([]);
  const [api4, setApi4] = useState([]);

  // أول API: جميع المنتجات
  useEffect(() => {
    axios
      .get("https://dummyjson.com/products")
      .then((res) => {
        setApi(res.data.products);
      })
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  // ثاني API: الموبايلات
  useEffect(() => {
    axios
      .get("https://dummyjson.com/products/category/smartphones")
      .then((res) => {
        setApi2(res.data.products);
      })
      .catch((err) => console.error("Error fetching smartphones:", err));
  }, []);

  // ثالث API: اللابتوبات
  useEffect(() => {
    axios
      .get("https://dummyjson.com/products/category/laptops")
      .then((res) => {
        setApi3(res.data.products);
      })
      .catch((err) => console.error("Error fetching laptops:", err));
  }, []);

  // رابع API: الإلكترونيات
  useEffect(() => {
    axios
      .get("https://fakestoreapi.com/products/category/electronics")
      .then((res) => {
        setApi4(res.data);
      })
      .catch((err) => console.error("Error fetching electronics:", err));
  }, []);


  return (
    <apiValue.Provider value={api}>
      <apiValue2.Provider value={api2}>
        <apiValue3.Provider value={api3}>
          <apiValue4.Provider value={api4}>{children}</apiValue4.Provider>
        </apiValue3.Provider>
      </apiValue2.Provider>
    </apiValue.Provider>
  );
}

export { AllData, apiValue, apiValue2, apiValue3, apiValue4 };
